import client from "./contentfullAPI";

export async function getBlogPosts() {
  const response = await client.getEntries({
    content_type: "blog",
    order: "-fields.date",
  });
  return response.items;
}
